// Integração RDO -> Gestor de Tarefas.
// Quando um RDO é finalizado, as atividades vinculadas a uma tarefa real
// refletem seu "% concluída" na tarefa (status + progress). Silencioso
// (sem toast) e best-effort por tarefa; a RLS garante que só as tarefas do
// próprio usuário são atualizadas (linkedTask de outra pessoa casa 0 linhas).
import { supabase } from "@/integrations/supabase/client";
import type { RDO } from "@/services/rdoStorageService";

type Activity = NonNullable<RDO["activities"]>[number];

// Deriva o status da tarefa a partir do percentual reportado.
function statusFromCompletion(completion: number): "completed" | "in_progress" | null {
  if (completion >= 100) return "completed";
  if (completion > 0) return "in_progress";
  return null; // 0% não altera o status (a tarefa pode nem ter começado)
}

/**
 * Reflete o progresso das atividades vinculadas nas tarefas reais.
 * Retorna quantas tarefas foram efetivamente atualizadas.
 */
export async function syncActivitiesToTasks(activities: Activity[] = []): Promise<number> {
  let updated = 0;
  for (const a of activities) {
    const taskId = a?.linkedTask;
    if (!taskId) continue;
    const completion = Math.max(0, Math.min(100, Math.round(a.completion ?? 0)));
    const patch: { progress: number; status?: string; updated_at: string } = {
      progress: completion,
      updated_at: new Date().toISOString(),
    };
    const status = statusFromCompletion(completion);
    if (status) patch.status = status;
    const { error, count } = await supabase
      .from("tasks")
      .update(patch, { count: "exact" })
      .eq("id", taskId);
    if (!error && (count ?? 0) > 0) updated++;
    else if (error) console.error("syncActivitiesToTasks:", error.message);
  }
  return updated;
}
